import React, {useState} from "react";
import ProductSerializer from "../../../lib/product";
import Base from "./base";
import {useRouter} from "next/router";
import RecaptchaClient from "../../../lib/client/recaptcha";

/**
 *
 * @param title
 * @param buttonText
 * @param successAlert
 * @param errorAlert
 * @param type
 * @param code
 * @param manufacturer
 * @param productName
 * @param amount
 * @param quantity
 * @param unit
 * @param images
 * @param allImages
 * @param nutrients
 * @param ingredients
 * @param traces
 * @param stores
 * @param labels
 * @returns {JSX.Element}
 * @constructor
 */
export default function Edit(
    { title, buttonText, successAlert, errorAlert, type, code, manufacturer, productName, amount, quantity, unit, images, allImages, nutrients, ingredients, traces, stores, labels }
)
{
    // init
    const router = useRouter();

    // variables
    const [successMessage, setSuccessMessage] = useState();
    const [errorMessage, setErrorMessage] = useState();

    /**
     *
     * @param event
     * @returns {Promise<unknown>}
     */
    function submit(event) {
        return new Promise(async resolve => {
            try {
                // prevent the form from being submitted
                event.preventDefault();

                // get the form-data and create the data to initialize the serializer from it
                let formData = new FormData(event.target.closest('form'));
                let productSerializer = new ProductSerializer();
                productSerializer.InitFromFormData(formData);

                // generate a queue-object
                const queueObject = productSerializer.generateImportObject();

                // get the recaptcha-token
                const recaptchaClient = new RecaptchaClient(process.env.recaptchaKey);
                const token = await recaptchaClient.execute('/insert/import');

                // make the api-call to submit the queue-object
                fetch(
                    '/api/queue/import/insert?locale=' + router.locale + '&type=' + encodeURIComponent(queueObject.type) + '&source=DirectInput' + '&token=' + encodeURIComponent(token),
                    {
                        method: 'POST', // *GET, POST, PUT, DELETE, etc.
                        mode: 'same-origin', // no-cors, *cors, same-origin
                        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: 'same-origin', // include, *same-origin, omit
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        redirect: 'follow', // manual, *follow, error
                        referrerPolicy: 'origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                        body: JSON.stringify(queueObject) // body data type must match "Content-Type" header
                    }
                )
                    .then(response => {
                        if (!response.ok) {
                            response.text().then(error => {
                                throw new Error(error);
                            });
                        }
                        return response.json();
                    })
                    .then(data => {
                        if('ok' === data.header.status) {
                            setSuccessMessage(successAlert);
                            resolve(true);
                        } else {
                            throw new Error(data.header.errors.toString());
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        setErrorMessage(errorAlert);
                        resolve(true);
                    });
            } catch (exception) {
                console.error(exception);
                resolve(true);
            }
        });
    }

    // render
    return (
        <>
            {/* Form */}
            <Base
                title={title}
                buttonText={buttonText}
                submitCallback={submit}
                type={type}
                code={code}
                manufacturer={manufacturer}
                productName={productName}
                amount={amount}
                quantity={quantity}
                unit={unit}
                images={images}
                allImages={allImages}
                nutrients={nutrients}
                ingredients={ingredients}
                traces={traces}
                stores={stores}
                labels={labels}
                successMessage={successMessage}
                errorMessage={errorMessage}
            />
        </>
    );
}